import React from "react";
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

const AreaChartBase = ({
  data,
  xKey,
  areas = [],
  height = 300,
  yLabel,
  showVerticalGrid = true,
  stacked = false,
  showLegend = true,
  singleArea = false,
}) => {
  const chartAreas = singleArea && areas.length ? [areas[0]] : areas;

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={data}
          margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#e2e8f0"
            vertical={showVerticalGrid}
          />

          <XAxis
            dataKey={xKey}
            tick={{ fill: "#64748b", fontSize: 11 }}
            axisLine={{ stroke: "#64748b" }}
            tickLine={{ stroke: "#64748b" }}
          />

          <YAxis
            type="number"
            domain={[0, 12]}
            ticks={[0, 3, 6, 9, 12]}
            tick={{ fill: "#64748b", fontSize: 11 }}
            axisLine={{ stroke: "#64748b" }}
            tickLine={{ stroke: "#64748b" }}
            padding={{ top: 0, bottom: 0 }}
            scale="linear"
            label={
              yLabel
                ? {
                    value: yLabel,
                    angle: -90,
                    position: "insideLeft",
                    offset: 5,
                    fill: "#808080",
                    fontSize: 11,
                  }
                : undefined
            }
          />


          <Tooltip
            cursor={{ fill: "#f1f5f9" }}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #e2e8f0",
              fontSize: 12,
            }}
          />

          {showLegend && 
            <Legend 
              verticalAlign="bottom" 
              height={36} 
              wrapperStyle={{ fontSize: 14 }}
              iconType="circle" 
              iconSize={16}
            />
          }

          {chartAreas.map(({ key, color, label }) => (
            <Area
              key={key}
              type="monotone"
              dataKey={key}
              name={label || key}
              stroke={color}
              fill={color} 
              fillOpacity={0.6}
              strokeWidth={1}
              dot={false}
              activeDot={false}
              stackId={stacked ? "stacked" : undefined}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default AreaChartBase;
